import React from "react"

// import Auth from "auth";
import { API } from "API"
import { ErrorsCallback, SuccessConfirm } from "alertService"
import * as Alert from "alertService"

import { APIPost, APIGet } from "services/APIRequest"
import UrlServer from "configs/UrlServer"
import {arrayObject} from "ConvertKey"

// @material-ui/core components =====
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons =====
import PersonAddIcon from "@material-ui/icons/PersonAdd"
import GroupIcon from "@material-ui/icons/Group";
import EditIcon from "@material-ui/icons/Edit";
// import DeleteForeverIcons from "@material-ui/icons/DeleteForever";
// import Check from "@material-ui/icons/Check";

// core components =====
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import NavPills from "components/NavPills/NavPills.jsx";

// ComponentsPage =====
import ListsUserPage from "./Lists";
import CreateUserPage from "./Create";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"
// import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  mt4: {
    marginTop: "30px"
  },
  titleIcon: {
    marginBottom: -7

  }
}
class UserMainManagementPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 0,
      currentUserData: null,
      listUserType: null,
    }
  }

  componentDidMount() {
    Alert.Loading(true)
    this.loadUserType(()=>{

    })
  }
  loadUserType(callback) {
    APIGet(UrlServer.URL_GET_USER_TYPE, ({datas}) => {
      const newConvertDatas = arrayObject(datas,[
        {
          oldKey:"code",
          newKey:"value"
        },
        {
          oldKey:"description",
          newKey:"name"
        }
      ]
      )
      this.setState({ listUserType:newConvertDatas}, () => {
        if (callback) callback()
      })
    })
  }
  setTabIndex = (index,callback,isNoSetNull = false) => {
    console.log(">>>>1 ",index)
      // var inv = setTimeout(() => {
      //   clearInterval(inv)
        this.setState({currentPage:index},()=>{
          if(index === 0 && !isNoSetNull){
            console.log(">>>>a ")
            this.setState({currentUserData:null},()=>{
              if(callback)callback()
            })
          }else{
            console.log(">>>>b ")
            if(callback)callback()
          }
        })
      // }, 150);
  }
  getTabIndex = (index) => {
    console.log(">>>>2 ",index)
    if(index === 0){
      this.setState({currentUserData:null},()=>{
        if(this.state.currentPage !== 0){
          // var inv = setTimeout(() => {
            // clearInterval(inv)
            this.setState({currentPage:0})
          // }, 50);
        }
      })
    }
  }
  setCurrentUserData = (userDataObject) => {
    this.setState({currentUserData:userDataObject})
  }
  render() {
    const { classes } = this.props

    return (
      <GridContainer>
        <GridItem xs={12}>
          {
            (this.state.listUserType)?
              <NavPills
                onChangeTabIndex={this.getTabIndex}
                color="info"
                active={this.state.currentPage}
                tabs={[
                  {
                    // <GroupIcon className={classes.titleIcon} /> 
                    tabIcon: GroupIcon,
                    tabButton: "รายชื่อผู้ใช้ระบบ",
                    tabContent: <ListsUserPage 
                                  callbacksetTabIndex = {this.setTabIndex} 
                                  callbackSetCurrentUserData = {this.setCurrentUserData}
                                  listUserType = {this.state.listUserType}
                                />
                  },
                  {
                    tabIcon: ((this.state.currentUserData)?EditIcon:PersonAddIcon),
                    tabButton: ((this.state.currentUserData)?"แก้ไขข้อมูลใช้":"สร้างผู้ใช้ระบบ"),
                    tabContent: <CreateUserPage 
                                  callbackSetTabIndex = {this.setTabIndex} 
                                  currentUserData={this.state.currentUserData}
                                  listUserType = {this.state.listUserType}
                                />
                  }
                ]}
              />
            :""
          } 
        </GridItem>
      </GridContainer>
    )
  }
}

export default withStyles(styles)(UserMainManagementPage)
